export default {
  methods: {
    showActivityAuditForWorksheet(worksheet) {
      if (!this.tenantSetup?.activityAuditsEnabled) {
        return false
      }
      return (worksheet?.activityAudits || []).length > 0
    }
  }
}
